import React from "react";
import "./side-menu-data.css";
import logo from "./../../../assets/images/logo.png";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PersonIcon from "@mui/icons-material/Person";
import BookIcon from "@mui/icons-material/Book";
import HistoryIcon from "@mui/icons-material/History";
import ForumIcon from "@mui/icons-material/Forum";
import StarHalfIcon from "@mui/icons-material/StarHalf";
import CampaignIcon from "@mui/icons-material/Campaign";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import GroupIcon from "@mui/icons-material/Group";
import PsychologyIcon from "@mui/icons-material/Psychology";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import { useTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { IoLogOutSharp } from "react-icons/io5";
import { Button } from "@mui/material";
import BookOnlineIcon from "@mui/icons-material/BookOnline";
import BadgeIcon from "@mui/icons-material/Badge";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import EventNoteIcon from "@mui/icons-material/EventNote";
import ModeOfTravelIcon from "@mui/icons-material/ModeOfTravel";
import HomeIcon from "@mui/icons-material/Home";
import { useLocation, useNavigate } from "react-router-dom";
import ManageHistoryIcon from "@mui/icons-material/ManageHistory";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import PagesIcon from "@mui/icons-material/Pages";
import { BiChevronRight } from "react-icons/bi";
import SettingsIcon from "@mui/icons-material/Settings";
import PriceChangeIcon from "@mui/icons-material/PriceChange";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import LiveHelpIcon from "@mui/icons-material/LiveHelp";
import AssignmentIcon from "@mui/icons-material/Assignment";
import TaskIcon from "@mui/icons-material/Task";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import GroupsIcon from "@mui/icons-material/Groups";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
const SideMenuData = () => {
  const navigate = useNavigate();
  const location = useLocation();
  let CurrentPagePath = location.pathname;
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const isMatch = useMediaQuery(theme.breakpoints.down("lg"));
  return (
    <>
      {isMatch ? (
        <div></div>
      ) : (
        <div
          className="tutor-panel-sider-container"
          style={{ position: isMatch ? "" : "fixed" }}
        >
          <div className="tutor-panel-sider-content-wraper">
            <div className="tutor-panel-sider-logo-container">
              <img src={logo} alt="logo" width="100px" />
            </div>
            <div className="side-menu-data-list-main">
              <ul className="side-menu-ul">
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/home"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/home");
                    }}
                  >
                    <HomeIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">home</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/dasboard"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/dasboard");
                    }}
                  >
                    <DashboardIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">dashboard</span>
                  </Button>
                </li>

                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/profile"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/profile");
                    }}
                  >
                    <PersonIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">profile</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/my-classes" ||
                      CurrentPagePath === "/my-classes/create" ||
                      CurrentPagePath === "/my-classes/view"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/my-classes");
                    }}
                  >
                    <BookIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">my classes</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/class-history" ||
                      CurrentPagePath === "/class-history/view" ||
                      CurrentPagePath === "/class-history/analytics"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/class-history");
                    }}
                  >
                    <HistoryIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">Class History</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/online-classes" ||
                      CurrentPagePath === "/online-class/analytics" ||
                      CurrentPagePath === "/online-class/view" ||
                      CurrentPagePath === "/online-class/create"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/online-classes");
                    }}
                  >
                    <BookOnlineIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">online classes</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/add-staff" ||
                      CurrentPagePath === "/add-staff/analytics" ||
                      CurrentPagePath === "/add-staff/add"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/add-staff");
                    }}
                  >
                    <GroupIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">Add Staff</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/tutor" ||
                      CurrentPagePath === "/tutor/analytics" ||
                      CurrentPagePath === "/tutor/add"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/tutor");
                    }}
                  >
                    <BadgeIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">Tutor</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/add-student" ||
                      CurrentPagePath === "/add-student/analytics" ||
                      CurrentPagePath === "/add-student/add"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/add-student");
                    }}
                  >
                    <MenuBookIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">Add student</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/organize-event" ||
                      CurrentPagePath === "/organize-event/analytics" ||
                      CurrentPagePath === "/organize-event/view" ||
                      CurrentPagePath === "/organize-event/create"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/organize-event");
                    }}
                  >
                    <EventNoteIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">Organize event</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/organize-trip" ||
                      CurrentPagePath === "/organize-trip/analytics" ||
                      CurrentPagePath === "/organize-trip/view" ||
                      CurrentPagePath === "/organize-trip/create" ||
                      CurrentPagePath === "/organize-trip/book"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/organize-trip");
                    }}
                  >
                    <ModeOfTravelIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">Organize trip</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/purchases-product" ||
                      CurrentPagePath === "/purchases-product/view" ||
                      CurrentPagePath === "/purchases-product/my-cart" ||
                      CurrentPagePath === "/purchases-product/message"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/purchases-product");
                    }}
                  >
                    <ShoppingCartIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">
                      Purchases Product
                    </span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/purchases-history" ||
                      CurrentPagePath === "/purchases-history/view"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/purchases-history");
                    }}
                  >
                    <ManageHistoryIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">
                      Purchases History
                    </span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/chat"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/chat");
                    }}
                  >
                    <ForumIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">chat inbox</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/rating" ||
                      CurrentPagePath === "/rating/view" ||
                      CurrentPagePath === "/rating/analytics"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/rating");
                    }}
                  >
                    <StarHalfIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">ratings</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/my-promotions" ||
                      CurrentPagePath === "/my-promotions/create"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/my-promotions");
                    }}
                  >
                    <CampaignIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">my promotions</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/notifications" ||
                      CurrentPagePath === "/notification/view"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/notifications");
                    }}
                  >
                    <NotificationsActiveIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">notifications</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/my-wallet"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/my-wallet");
                    }}
                  >
                    <AccountBalanceWalletIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">my wallet</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/dispute" ||
                      CurrentPagePath === "/dispute/view"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/dispute");
                    }}
                  >
                    <PsychologyIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">dispute</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/invoice" ||
                      CurrentPagePath === "/invoice/create" ||
                      CurrentPagePath === "/invoice/view" ||
                      CurrentPagePath === "/invoice/preview"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/invoice");
                    }}
                  >
                    <PriceChangeIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">invoice</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/time-table"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/time-table");
                    }}
                  >
                    <CalendarMonthIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">Time Table</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/attendance"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/attendance");
                    }}
                  >
                    <GroupsIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">attendance</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/salary-requests"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/salary-requests");
                    }}
                  >
                    <LocalAtmIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">salary request</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/leave-request" ||
                      CurrentPagePath === "/leave-request/view"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/leave-request");
                    }}
                  >
                    <LiveHelpIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">leave request</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/assignment" ||
                      CurrentPagePath === "/assignment/view"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/assignment");
                    }}
                  >
                    <AssignmentIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">Assignment</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/submited-task" ||
                      CurrentPagePath === "/submited-task/view"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/submited-task");
                    }}
                  >
                    <TaskIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">Submited task</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/result" ||
                      CurrentPagePath === "/result/view"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/result");
                    }}
                  >
                    <FactCheckIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">result</span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/transaction-history" ||
                      CurrentPagePath === "/transaction-history/view"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/transaction-history");
                    }}
                  >
                    <PointOfSaleIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">
                      transaction history
                    </span>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/banner" ||
                      CurrentPagePath === "/add-most-populer-tutors" ||
                      CurrentPagePath === "/about-us" ||
                      CurrentPagePath === "/add-populer-courses" ||
                      CurrentPagePath === "/add-our-student-says" ||
                      CurrentPagePath === "/add-upcomming-events" ||
                      CurrentPagePath === "/add-our-latest-update"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    aria-describedby={id}
                    onClick={handleClick}
                  >
                    <PagesIcon className="side-menu-icon" />
                    <div className="side-menu-more-pages">
                      <span className="side-menu-page-title">
                        website pages
                      </span>
                      <BiChevronRight size={30} className="side-menu-icon" />
                    </div>
                  </Button>
                </li>
                <li className="tutor-panel-sider-list-item">
                  <Button
                    variant="text"
                    className={
                      CurrentPagePath === "/settings" ||
                      CurrentPagePath === "/settings/invoice" ||
                      CurrentPagePath === "/settings/tc"
                        ? "side-menu-active-page"
                        : "side-menu-page"
                    }
                    onClick={() => {
                      navigate("/settings");
                    }}
                  >
                    <SettingsIcon className="side-menu-icon" />
                    <span className="side-menu-page-title">settings</span>
                  </Button>
                </li>
                <br />
              </ul>
            </div>
            <div className="first-tutor-panel-sider-log-out-container">
              <Button
                variant="text"
                className="logout-button"
                onClick={() => {
                  navigate("/");
                }}
              >
                <span>Logout</span>
                <IoLogOutSharp className="side-menu-icon" />
              </Button>
            </div>
          </div>
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
          >
            <Typography sx={{ p: 1 }}>
              <Button
                variant="text"
                className={
                  CurrentPagePath === "/banner"
                    ? "side-menu-active-page"
                    : "side-menu-page"
                }
                onClick={() => {
                  navigate("/banner");
                }}
              >
                Banner
              </Button>
              <Button
                variant="text"
                className={
                  CurrentPagePath === "/add-populer-courses"
                    ? "side-menu-active-page"
                    : "side-menu-page"
                }
                onClick={() => {
                  navigate("/add-populer-courses");
                }}
              >
                Populer Courses
              </Button>
              <Button
                variant="text"
                className={
                  CurrentPagePath === "/add-most-populer-tutors"
                    ? "side-menu-active-page"
                    : "side-menu-page"
                }
                onClick={() => {
                  navigate("/add-most-populer-tutors");
                }}
              >
                most populer tutors
              </Button>
              <Button
                variant="text"
                className={
                  CurrentPagePath === "/about-us"
                    ? "side-menu-active-page"
                    : "side-menu-page"
                }
                onClick={() => {
                  navigate("/about-us");
                }}
              >
                about us
              </Button>
              <Button
                variant="text"
                className={
                  CurrentPagePath === "/add-our-student-says"
                    ? "side-menu-active-page"
                    : "side-menu-page"
                }
                onClick={() => {
                  navigate("/add-our-student-says");
                }}
              >
                Our Student says
              </Button>{" "}
              <Button
                variant="text"
                className={
                  CurrentPagePath === "/add-upcomming-events"
                    ? "side-menu-active-page"
                    : "side-menu-page"
                }
                onClick={() => {
                  navigate("/add-upcomming-events");
                }}
              >
                Upcomming Events
              </Button>
              <Button
                variant="text"
                className={
                  CurrentPagePath === "/add-our-latest-update"
                    ? "side-menu-active-page"
                    : "side-menu-page"
                }
                onClick={() => {
                  navigate("/add-our-latest-update");
                }}
              >
                Our latest update
              </Button>
            </Typography>
          </Popover>
        </div>
      )}
    </>
  );
};
export default SideMenuData;
